import { render, staticRenderFns } from "./exchange-agreement.vue?vue&type=template&id=2c003ca6&"
import script from "./exchange-agreement.vue?vue&type=script&lang=js&"
export * from "./exchange-agreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports